
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AppUserAvatar extends Vue {
  @Prop({ type: String, default: null }) readonly image: string;
  @Prop({ type: String, default: null }) readonly name: string;

  get initials() {
    const { name } = this;

    if (!name) return "";

    const nameParts = name.split(" ");

    return nameParts[0]?.charAt(0).toUpperCase() + nameParts[1]?.charAt(0).toUpperCase();
  }
}
